import { commonDeDe } from './locales/de-DE/common';
import { featuresDeDe } from './locales/de-DE/features';
import { commonEnGb } from './locales/en-GB/common';
import { featuresEnGb } from './locales/en-GB/features';
import { commonEsEs } from './locales/es-ES/common';
import { featuresEsEs } from './locales/es-ES/features';
import { commonItIt } from './locales/it-IT/common';
import { featuresItIt } from './locales/it-IT/features';
import { commonSrRs } from './locales/sr-RS/common';
import { featuresSrRs } from './locales/sr-RS/features';
import type { I18nResources } from './types';

declare global {
  interface I18nNamespaceRegistry {
    common: typeof commonEnGb;
    features: typeof featuresEnGb;
  }
}

export const platformI18nResources: I18nResources<'common' | 'features'> = {
  'en-GB': {
    common: commonEnGb,
    features: featuresEnGb,
  },
  'es-ES': {
    common: commonEsEs,
    features: featuresEsEs,
  },
  'de-DE': {
    common: commonDeDe,
    features: featuresDeDe,
  },
  'sr-RS': {
    common: commonSrRs,
    features: featuresSrRs,
  },
  'it-IT': {
    common: commonItIt,
    features: featuresItIt,
  },
};
